import { ILocationResult } from 'src/models/general';

export const filterOptionLocation = (param: ILocationResult) =>
  Object.values(param)
    .slice(0, 3)
    .filter((opt) => opt);
